export const NANO_SECOND = 1;
export const MILLI_SECOND = NANO_SECOND * 1000;
export const MICRO_SECOND = MILLI_SECOND * 1000;
export const SECOND = MICRO_SECOND * 1000;
export const MINUTE = SECOND * 60;
export const HOUR = MINUTE * 60;
